import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-filter-panel',
  templateUrl: './filter-panel.component.html',
  styleUrls: ['./filter-panel.component.scss']
})
export class FilterPanelComponent {
  @Input() isFilterPanelValid = true;
  @Input() formGroup: UntypedFormGroup;

  @Input()
  isEditMode = true;

  @Output() isEditModeChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @HostListener('click')
  onHostClick() {
    if (!this.isEditMode) {
      this.isEditModeChange.emit(true);
    }
  }

  closeEditMode() {
    this.isEditModeChange.emit(false);
  }
}
